import CSS from 'csstype';
import React, { useState } from 'react';

import { FONT_WEIGHT } from '~/src/dash/components/text/common';
import { fontSizing, usePanel } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

const getBackgroundColor = (
  theme: Record<string, string>,
  backgroundColor: string | undefined,
  isHover: boolean = false,
  clearBackground: boolean = false,
  disabled: boolean = false,
) => {
  switch (true) {
    case disabled || (clearBackground && isHover):
      return theme.primaryButtonDisabled;
    case clearBackground:
      return 'inherit';
    case isHover:
      return theme.primaryButtonHovered;
    default:
      return backgroundColor || theme.primaryButton;
  }
};

interface IButtonProps {
  large?: boolean;
  clearBackground?: boolean;
  backgroundColor?: string;
  color?: string;
  onClick: (props?: any | null) => void;
  disabled?: boolean;
  allCaps?: boolean;
  enableTextWrap?: boolean;
  style?: CSS.Properties;
  className?: string;
  children?: any;
}

export const ButtonV2 = ({
  large,
  clearBackground,
  backgroundColor,
  color,
  onClick,
  disabled,
  allCaps,
  enableTextWrap,
  style,
  className = '',
  children,
}: IButtonProps) => {
  const { theme } = usePanel();
  const [isHover, setIsHover] = useState(false);

  return (
    <button
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={disabled ? () => null : onClick}
      className={className}
      style={{
        display: 'inline-block',
        borderWidth: 0,
        lineHeight: 'inherit',
        fontFamily: 'inherit',
        fontStyle: 'inherit',
        textTransform: allCaps ? 'uppercase' : 'inherit',
        whiteSpace: enableTextWrap ? 'normal' : 'nowrap',
        margin: 0,
        padding: '8px 16px',
        borderRadius: '4px',
        backgroundColor: getBackgroundColor(
          theme,
          backgroundColor,
          isHover,
          clearBackground,
          disabled,
        ),
        fontSize: large ? fontSizing.large : fontSizing.base,
        fontWeight: FONT_WEIGHT.bold,
        color: clearBackground ? color || publicaColors.gray : color || theme.primaryButtonText,
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
    >
      {children}
    </button>
  );
};
